import * as React from 'react';
import { CSSProperties } from 'react';
import styled from 'styled-components';
import { constants } from '../../constants';

interface ComponentProps {
    color?: string;
    dark?: boolean;
    light?: boolean;
    altColor?: boolean;
    altDark?: boolean;
    style?: CSSProperties & CSSStyleDeclaration;
    onClick?: () => any;
    children?: any;
}

interface StyledComponentProps {
    noBreakPoint?: boolean;
    center?: boolean;
    textColor?: string;
    strong?: boolean;
    light?: boolean;
}

const StyledH1 = styled<StyledComponentProps, 'div'>('div')`
    font-size: 2.5em;
    font-weight: ${props => (props.strong ? 500 : 100)};
    font-family: ${constants.text.displayFont.fontFamily};
    letter-spacing: ${props => (props.light ? '0.04em' : 0)};
    color: ${props => props.textColor};
    ${props =>
        props.center
            ? ` display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;`
            : ''} 
    @media (max-width: ${props =>
        props.noBreakPoint ? '0' : constants.layout.breakpoint.break1}px){ 
           font-size: 2em; 
        }
`;

const H1: React.StatelessComponent<ComponentProps> = ({
    color,
    dark = false,
    light = false,
    altColor = false,
    altDark = false,
    style,
    onClick,
    children,
    ...rest
}) => {
    let textColor = '';

    if (color) {
        textColor = color;
    } else if (altColor) {
        textColor = constants.color.grey34;
    } else if (altDark) {
        textColor = constants.color.grey75;
    } else if (dark) {
        textColor = constants.color.dark;
    } else if (light) {
        textColor = constants.color.light;
    } else {
        textColor = constants.color.primaryDark;
    }

    return (
        <StyledH1
            style={style}
            textColor={textColor}
            light={light}
            onClick={onClick}
            {...rest}
        >
            {children}
        </StyledH1>
    );
};

export default H1;

// color: ${props => (props.color) ? props.color : 'red'};
//   box-shadow: -7px 11px 78px -24px rgba(0,0,0,0.16);



// WEBPACK FOOTER //
// ./src/js/components/Primatives/H1.tsx